var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._t("title")],2),_vm._v(" "),_c('v-card-text',[_vm._t("content")],2),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_vm._t("negative-button"),_vm._v(" "),_vm._t("positive-button")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69c3a208","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/BaseModal.vue
// module id = null
// module chunks = 